import { CustomAPI } from '@sydle/ui-api';
import { getMenuConfigs } from './get-menu-configs';

const SITE_API_CLASS_ID = '62dfee51da886c7570f29a1b';
export const siteCustomAPI = new CustomAPI(SITE_API_CLASS_ID);

const siteFacade = {
  getMenuConfigs,
};

export function createSiteAPI(): void {
  if (typeof window !== undefined) {
    window.siteFacade = siteFacade;
  }
}

export type SiteFacade = typeof siteFacade;
